import { render, staticRenderFns } from "./EditSelfMedicationModal.vue?vue&type=template&id=125eef6c&scoped=true"
import script from "./EditSelfMedicationModal.vue?vue&type=script&lang=js"
export * from "./EditSelfMedicationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125eef6c",
  null
  
)

export default component.exports